"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray,
  handleNestedProp = dataUtils.handleNestedProp;
var toggleElement = function toggleElement(array, element) {
  var index = array.indexOf(element);
  if (index === -1) {
    array.push(element);
  } else {
    array.splice(index, 1);
  }
  return array;
};
var SubNavLinks = function SubNavLinks(_ref) {
  var reducedHeight = _ref.reducedHeight,
    totalSetSize = _ref.totalSetSize,
    name = _ref.name,
    displayNavInTwoColumns = _ref.displayNavInTwoColumns,
    market = _ref.market,
    theme = _ref.theme,
    subNavigationItems = _ref.subNavigationItems,
    keyHandlerMethod = _ref.keyHandlerMethod,
    enableAccordion = _ref.enableAccordion,
    mobileNavActive = _ref.mobileNavActive;
  var _useState = (0, _react.useState)(0),
    activeAccordion = _useState[0],
    setActiveAccordion = _useState[1];
  var refList = {};
  var keyHandler = function keyHandler() {
    keyHandlerMethod.apply(void 0, arguments);
  };
  var handleAccordionAction = function handleAccordionAction(index) {
    if (activeAccordion === index) {
      setActiveAccordion(null);
    } else {
      setActiveAccordion(index);
    }
  };
  var publishMenuClickToDataLayer = function publishMenuClickToDataLayer(mainMenu, linkUrl, subMenu, market) {
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'menu_click',
        comp_page: {
          position: 'top menu',
          main_category: mainMenu ? mainMenu.toLowerCase() : null,
          selected_category: subMenu ? subMenu.toLowerCase() : null
        }
      });
      if (['/concesionarios', '/localizador-concessionarios', '/loyda-lahin-jalleenmyyjasi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'dealer_locator_click',
          comp_page: {
            position: 'top menu'
          }
        });
      }
      if (['/comprar/configurador', '/loquiero/configurador', '/osta/rakenna-oma-mitsubishi', '/osta/rakenna-oma-mitsubishi/rakenna-autosi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'car_configuration_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            color: null,
            upholstery: null,
            accesories: null,
            fuel_type: null,
            price: null,
            currency: null
          }
        });
      }
      if (['/servicio/citataller', '/omistajuus/varaa-huolto'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'maintenance_request_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
      if (['/prueba', '/test-drive', '/varaa-koeajo'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'test_drive_request_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
    }
  };
  var renderItemLink = function renderItemLink(settings) {
    var checkedSettings = {
      link: handleNestedProp(settings, 'settings.link'),
      i: handleNestedProp(settings, 'settings.i'),
      totalSetSize: handleNestedProp(settings, 'settings.totalSetSize'),
      name: handleNestedProp(settings, 'settings.name'),
      market: handleNestedProp(settings, 'settings.market')
    };
    var link = checkedSettings.link;
    var market = checkedSettings.market;
    var checkedLink = {
      label: handleNestedProp(link, 'link.label'),
      url: handleNestedProp(link, 'link.url'),
      openNewTab: handleNestedProp(link, 'link.openNewTab')
    };
    var setSize = checkedSettings.totalSetSize;
    var posInSet = checkedSettings.i + 1;
    var name = checkedSettings.name + "_" + checkedLink.label;
    refList[name] = refList[name] || {};
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: checkedLink.label + "-" + checkedSettings.i,
      className: _navigationHeader["default"].navItemLink + " menu-panel-sub-list-item",
      ref: function ref(el) {
        refList[name][checkedSettings.i] = el;
        return el;
      },
      onKeyUp: function onKeyUp(e) {
        return keyHandler(e, checkedSettings.i, refList[name][checkedSettings.i]);
      },
      role: "menuitem",
      "aria-setsize": setSize,
      "aria-posinset": posInSet,
      "data-menu-item-name": name,
      "data-menu-item-parent-name": checkedSettings.name
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: _navigationHeader["default"].dropDownLinkAnchor,
      href: "" + checkedLink.url,
      "data-section": checkedSettings.name,
      target: checkedLink.openNewTab ? '_blank' : '',
      onClick: function onClick() {
        return publishMenuClickToDataLayer(checkedSettings.name, checkedLink.url, checkedLink.label, market);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _navigationHeader["default"].navLinkLabel + " " + theme.introCopy
    }, checkedLink.label)));
  };
  var renderLinks = function renderLinks(params) {
    var links = params.links,
      index = params.index,
      title = params.title,
      mobileNavActive = params.mobileNavActive;
    var canAccordionActive = enableAccordion === true && !!title;
    var activeIndex = enableAccordion && index === activeAccordion;
    return !isEmptyArray(links) && links !== ' ' && /*#__PURE__*/_react["default"].createElement("ul", {
      className: _navigationHeader["default"].navLinkList + " " + _navigationHeader["default"].linksList + " " + (reducedHeight ? _navigationHeader["default"].reduced : '') + " " + (canAccordionActive === true && "" + _navigationHeader["default"].subNavAccordion) + " " + (activeIndex === true && "" + _navigationHeader["default"].isActive) + " " + _navigationHeader["default"].newNavList
    }, links.map(function (link, i) {
      return renderItemLink({
        link: link,
        i: i,
        totalSetSize: totalSetSize,
        name: name,
        displayNavInTwoColumns: displayNavInTwoColumns,
        market: market
      });
    }));
  };
  var isAllColumnTitleLess = function isAllColumnTitleLess(subNavigationItems) {
    return subNavigationItems.every(function (item) {
      return (item == null ? void 0 : item.title) === null;
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme.row
  }, !isEmptyArray(subNavigationItems) && subNavigationItems.map(function (navItem, index) {
    var _clsx, _clsx2, _clsx3;
    var links = navItem.links,
      title = navItem.title;
    var isAccordionOpen = activeAccordion === index;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])((_clsx = {}, _clsx[theme['col-xs-12']] = !mobileNavActive, _clsx[theme['col-md-4']] = !mobileNavActive, _clsx[theme['col-xs-12']] = mobileNavActive, _clsx))
    }, enableAccordion && !!title ? /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: (0, _clsx4["default"])(_navigationHeader["default"].subNavTitle, _navigationHeader["default"].subNavTitleAccordionToggle, theme.mmcIconChevronDown, (_clsx2 = {}, _clsx2[_navigationHeader["default"].isActive] = isAccordionOpen, _clsx2)),
      onClick: function onClick() {
        handleAccordionAction(index);
      }
    }, title) : /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx4["default"])(_navigationHeader["default"].subNavTitle, (_clsx3 = {}, _clsx3[_navigationHeader["default"].noTitle] = isAllColumnTitleLess(subNavigationItems), _clsx3))
    }, title), renderLinks({
      links: links,
      reducedHeight: reducedHeight,
      totalSetSize: totalSetSize,
      name: name,
      displayNavInTwoColumns: displayNavInTwoColumns,
      market: market,
      index: index,
      title: title,
      mobileNavActive: mobileNavActive
    }));
  }));
};
SubNavLinks.displayName = 'SubNavLinks';
SubNavLinks.defaultProps = {
  subNavigationItems: [],
  enableAccordion: false
};
var _default = exports["default"] = SubNavLinks;